
import axios from "axios";

export const envioNotificaciones= async (entidad) => {


    let data = JSON.stringify({
        "nombre": entidad.nombre,
        "correo": entidad.correo,
        "mensaje": entidad.notas,
        "celular": entidad.celula,
        "tipo" : entidad.opcion,
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/63a82115-9b01-408c-b089-51a97d374167',
       // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/63a82115-9b01-408c-b089-51a97d374167', //test
        headers: {
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });



}
